import FixedButton, {
  FixedButtonContainer,
} from "components/common/buttons/FixedButtons";
import { Forward } from "components/common/Icons";
import { trackPageAction } from "lib/analytics/core/actions";
import { useRouter } from "next/router";
import { TYPO } from "styles/Typo";

export default function BriefingPagenationButton({
  isMobile,
  currentPage,
  setCurrentPage,
  totalPages,
}: {
  isMobile: boolean;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
}) {
  const router = useRouter();
  const from = router.query?.from;
  return (
    <FixedButtonContainer
      isMobile={isMobile}
      customStyle={{ background: "transparent" }}
    >
      <div className="flex  gap-4 items-center justify-center">
        <button
          className={`${
            currentPage === 0 ? "bg-gray10" : "bg-gray15 cursor-pointer"
          } rounded-[24px] flex items-center px-[18px] py-[13px]  justify-center  h-[60px] w-[60px]`}
          onClick={() => {
            trackPageAction("slider_brief");
            if (currentPage > 0) {
              setCurrentPage(currentPage - 1);
            }
            router.replace(
              `/briefing?step=${currentPage - 1}${from ? `&from=${from}` : ""}`,
              undefined,
              {
                shallow: true,
              }
            );
          }}
          data-gtm-id="briefing-pagenation-prev-button"
        >
          {/* <p className={`${TYPO.TYPO5_MD} text-gray80`}>이전</p> */}
          <div className="rotate-180">
            <ArrowIcon
              color={currentPage === 0 ? "var(--gray40)" : "var(--gray80)"}
            />
          </div>
        </button>

        <button
          className="bg-gray90 rounded-[24px] flex items-center px-[18px] py-[13px] justify-center cursor-pointer  h-[60px] w-[60px]"
          onClick={() => {
            trackPageAction("slider_brief");

            setCurrentPage(currentPage + 1);
            router.replace(
              `/briefing?step=${currentPage + 1}${from ? `&from=${from}` : ""}`,
              undefined,
              {
                shallow: true,
              }
            );
          }}
          data-gtm-id="briefing-pagenation-next-button"
        >
          <ArrowIcon color="white" />
        </button>
      </div>
    </FixedButtonContainer>
  );
}

const ArrowIcon = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M16.675 12.9982L5.5 12.9982C5.21667 12.9982 4.97917 12.9023 4.7875 12.7107C4.59583 12.519 4.5 12.2815 4.5 11.9982C4.5 11.7148 4.59583 11.4773 4.7875 11.2857C4.97917 11.094 5.21667 10.9982 5.5 10.9982L16.675 10.9982L11.775 6.09816C11.575 5.89816 11.4792 5.66482 11.4875 5.39816C11.4958 5.13149 11.6 4.89816 11.8 4.69816C12 4.51482 12.2333 4.41899 12.5 4.41066C12.7667 4.40232 13 4.49816 13.2 4.69816L19.8 11.2982C19.9 11.3982 19.9708 11.5065 20.0125 11.6232C20.0542 11.7398 20.075 11.8648 20.075 11.9982C20.075 12.1315 20.0542 12.2565 20.0125 12.3732C19.9708 12.4898 19.9 12.5982 19.8 12.6982L13.2 19.2982C13.0167 19.4815 12.7875 19.5732 12.5125 19.5732C12.2375 19.5732 12 19.4815 11.8 19.2982C11.6 19.0982 11.5 18.8607 11.5 18.5857C11.5 18.3107 11.6 18.0732 11.8 17.8732L16.675 12.9982Z"
        fill={color}
      />
    </svg>
  );
};
